import axios from 'axios'
import Cookies from 'js-cookie'
import moment from 'moment'

/**
 * Authentication library for projects developed in
 * Marciano Digital Agency
 * @version 1.0.1
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default class MSAuth {
  /**
   * @param {string} authURL - The authentication API URL
   * @param {string} refreshTokenURL - The refresh token API URL
   * @param {string, object} successRoute - The route to be redirected on authentication success
   * @param {string, object} errorRoute - The route to be redirected on authentication success
   */
  constructor (
    authURL,
    refreshTokenURL,
    successRoute,
    logoutRoute = '/',
    errorRoute = '/'
  ) {
    this.__authURL__ = authURL
    this.__refreshTokenURL__ = refreshTokenURL
    this.__successRoute__ = successRoute
    this.__errorRoute__ = errorRoute
    this.__logoutRoute__ = logoutRoute
    this.__inactiveTimestamp__ = moment()
    window.onblur = this.restartInactivityCounter.bind(this)
    window.onfocus = this.restartActivityCounter.bind(this)
    this.__sessionAlertTimer__ = setInterval(this.alertSessionExpiraton, 960000)
  }

  alertSessionExpiraton () {
    let expiration =
      (new Date(Cookies.set('auth-token-expires')).getTime() -
        new Date().getTime()) /
      1000 /
      60
    if (expiration <= 60) {
      alert(
        'Tu sesión expirará en ' +
          expiration +
          ' minutos. te recomendamos guardar tu trabajo e iniciar sesión nuevamente'
      )
    }
    console.log(expiration)
  }

  restartActivityCounter (e) {
    console.log('restarting activity counter', e)
    console.log(this.__inactiveTimestamp__)
    console.log(Cookies.get('auth-refresh-token'))
    console.log(this.__refreshTokenURL__)
    axios
      .post(this.__refreshTokenURL__, {
        token: Cookies.get('auth-refresh-token')
      })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.warn(error)
      })
  }

  restartInactivityCounter (e) {
    console.log('restarting inactivity counter', e)
    this.__inactiveTimestamp__ = moment()
  }

  set redirectURL (route) {
    if (typeof route === 'object') {
      this.__redirectRoute__ = route
    } else {
      throw new Error('The route must be a route object')
    }
  }

  get logoutRoute () {
    return this.__logoutRoute__
  }
  /**
   * Authentication method
   * @param username
   * @param password
   * @param rememberMe
   * @returns {Promise<AxiosResponse<any>>}
   */
  authenticate (username, password, rememberMe) {
    this.logout()
    return axios
      .post(this.__authURL__, {
        username: username,
        password: password,
        rememberMe: rememberMe
      })
      .then(response => {
        let authTokenOptions = {}
        let refreshTokenOptions = {}
        let authTokenExpires = new Date(
          new Date().getTime() + response.data.tokenLife * 1000
        )

        if (response.data.rememberMe) {
          // If expires is not set, the cookie will be saved as a session cookie.
          authTokenOptions.expires = authTokenExpires
          refreshTokenOptions.expires = new Date(
            new Date().getTime() + response.data.refreshTokenLife * 1000
          )
        }

        Cookies.set('auth-token', response.data.token, authTokenOptions)
        Cookies.set('auth-token-expires', authTokenExpires, authTokenOptions)
        Cookies.set(
          'auth-refresh-token',
          response.data.refreshToken,
          refreshTokenOptions
        )
        return response
      })
      .catch(error => {
        this.logout()
        throw error
      })
  }

  /**
   * Return the URL or Route
   * to be redirected on success.
   */
  get redirectURL () {
    return this.__redirectRoute__ || this.__successRoute__
  }

  /**
   * Removes the session cookies
   * from the client
   */
  logout () {
    Cookies.remove('auth-token')
    Cookies.remove('auth-refresh-token')
  }

  /**
   * Returns if the user is authenticated
   * or not
   * @returns {boolean}
   */
  isAuthenticated () {
    return !!Cookies.get('auth-token')
  }

  /**
   * Returns the current authorization token
   * @returns {string} authorization token
   */
  token () {
    return Cookies.get('auth-token')
  }
}



// WEBPACK FOOTER //
// ./src/utilis/ms-auth.js